<template>
  <div class="appHouseholdManage">
    <div class="filters">
      <el-form :inline="true">
        <!-- 选择日期 -->
        <el-form-item :label="$t('lang.lab_createFeeHTime')">
          <el-date-picker type="date" :placeholder="$t('lang.lab_startDate')" value-format="timestamp" v-model="startTime"></el-date-picker>
          <span style="padding: 0 1px">至</span>
          <el-date-picker type="date" :placeholder="$t('lang.lab_endDate')" value-format="timestamp" v-model="endTime"></el-date-picker>
        </el-form-item>
        <!-- 选择楼号 -->
        <el-form-item>
          <el-select v-model="houseId" @change="selectUnit" filterable>
            <el-option key :label="$t('lang.lab_floorName')" value></el-option>
            <el-option
              v-for="(item,index) in floorList"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 选择单元号 -->
        <el-form-item>
          <el-select v-model="unitid" @change="selectRoom" filterable>
            <el-option key :label="$t('lang.lab_unitName')" value></el-option>
            <el-option
              v-for="(item,index) in unitList"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 选择房间号 -->
        <el-form-item>
          <el-select v-model="roomid" filterable>
            <el-option key :label="$t('lang.lab_roomName')" value></el-option>
            <el-option
              v-for="(item,index) in roomList"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 收费方式 -->
        <el-form-item :label="$t('lang.lab_payMethod')" prop="payMethod">
          <el-select v-model="payMethod" >
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.lab_payMethod')" value></el-option>
            <el-option
              v-for="(item,index) in payMethodList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            class="searchInput"
            v-model="searchFeeName"
            :placeholder="$t('lang.lab_feeName')"
          ></el-input>
        </el-form-item>
        <!-- 关键字 -->
        <el-form-item>
          <el-input
            class="seachInput"
            v-model="keyword"
            :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_username')"
          ></el-input>
        </el-form-item>
        <el-switch style="margin-left: 10px; margin-right: 10px;" v-if="isRelationButton==1" active-text="收费减免" v-model="switchValue"> </el-switch>
        <el-button type="primary" @click="submit()">{{$t('lang.btn_search')}}</el-button>
        
        <!-- <el-button type="primary" @click="uploadFileDialog()">{{$t('lang.lab_mobile')}}</el-button> -->
   
        <el-button type="primary"  @click="excelDownloadClick">{{$t('lang.btn_excelDl')}}</el-button>
        <el-button type="primary"  :disabled="!multipleSelection.length" @click="combinedInvoicing()">{{"合并开票"}}</el-button>
        <el-button type="primary"  :disabled="!multipleSelection.length" @click="combinedReceiptNumber()">{{"合并开收据"}}</el-button>
         <el-switch style="margin-left: 10px; margin-right: 10px;"  active-text="未转款" v-model="isBackFee"> </el-switch>
      </el-form>
    </div>
    <el-card>
      <div slot="header" class="clearfix">
        <el-row style="margin-left:2%;text-align: start;">
          <el-col :span="24">收款金额合计：{{receivedAmountCount}}</el-col>
        </el-row>
      </div>
      <el-table
        :data="tableData"
        class="wid100"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :expand-row-keys="expands"
        @expand-change="rowClick"
        :row-key="getRowKeys"
      >
        <!-- checkbox -->
         <el-table-column type="selection" width="55" v-if="appHouseholdManageListcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          :label="$t('lang.lab_index')"
          width="55"
        ></el-table-column>
        <!-- 展开区域-->
        <el-table-column width="30" type="expand" >
          <template slot-scope="scope">
              <el-table label-position="left" inline class="demo-table-expand" :data= "scope.row.ruleItemData"  max-height="300">
                   <el-table-column label="收费项目" prop="feeName">
                  </el-table-column>
                  <el-table-column label="应收金额" prop="receiveAmount">
                  </el-table-column>
                  <el-table-column label="收款金额" prop="thisAmount">
                  </el-table-column>
                  <el-table-column label="折扣金额" prop="discountDetail">
                  </el-table-column>
                  <el-table-column label="费用期间" prop="period">
                    <template slot-scope="scope" >
                       <span v-if="scope.row.feeFlag=='1003006'">
                         {{scope.row.period}}
                      </span>
                      <span v-else>
                        -
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column  label="计费开始时间" prop="beginDate">
                     <template slot-scope="scope" >
                       <span v-if="scope.row.feeFlag=='1003006'">
                         {{scope.row.beginDate|timeYMD}}
                      </span>
                      <span v-else>
                        -
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="计费结束时间" prop="minEndDate">
                    <template slot-scope="scope">
                       <span v-if="scope.row.feeFlag=='1003006'">
                         {{scope.row.minEndDate|timeYMD}}
                      </span>
                      <span v-else>
                        -
                      </span>
                    </template>
                  </el-table-column>
                   <el-table-column label="收款人" prop="creatorName">
                  </el-table-column>

              </el-table>
         </template>
        </el-table-column>
        <!-- 用户名 -->
        <el-table-column width="100"  prop="childName" :label="$t('lang.lab_ownerName')"></el-table-column>
        <!-- 手机 -->
        <el-table-column prop="mobile"   width="120" :label="$t('lang.lab_phone')"></el-table-column>
        <!-- 小区 -->
        <el-table-column prop="gardenName"  width="100" :label="$t('lang.lab_village')"></el-table-column>
        <!-- 楼号 -->
        <el-table-column width="60" prop="houseName" :label="$t('lang.lab_buildingnum')"></el-table-column>
        <!-- 单元号 -->
        <el-table-column width="60" prop="unitName" :label="$t('lang.resourUnit')"></el-table-column>
        <!-- 房间号 -->
        <el-table-column prop="roomName" :label="$t('lang.lab_roomnum')"></el-table-column>
        <!-- 建筑面积 -->
        <el-table-column prop="buildArea" :label="$t('lang.lab_preHouseholdArea')"></el-table-column>

        <el-table-column prop="feeName" :label="$t('lang.lab_feeName')" width="150"></el-table-column>
        <el-table-column prop="feeTypeCdName" :label="$t('lang.lab_feeTypeCdName')" width="100"></el-table-column>
        <el-table-column prop="receivedAmount" :label="$t('lang.lab_receivedAmountH')"></el-table-column>
        <!-- 折扣金额 -->
        <el-table-column prop="discount" label="折扣金额"></el-table-column>
        <!-- 尾差金额 -->
        <el-table-column prop="feeLast" label="尾差金额"></el-table-column>
        <el-table-column width="120px" prop="createTime" :label="$t('lang.lab_createFeeHTime')">
          <template slot-scope="scope">
            {{scope.row.createTime|timeYMD}}
          </template>
        </el-table-column>
      <!-- 缴费起始时间 -->
        <!-- <el-table-column width="120px" prop="startTime" :label="$t('lang.lab_startFeeHTime')"  >
          <template slot-scope="scope" >
            <span v-if="scope.row.feeFlag=='1003006'">
                {{scope.row.startTime|timeYMD}}
            </span>
            <span v-else>
              -
            </span>
          </template>
        </el-table-column> -->
        <!-- 缴费结束时间 -->
        <!-- <el-table-column width="120px" prop="endTime"  :label="$t('lang.lab_endFeeHTime')">
          <template slot-scope="scope">
            <span v-if="scope.row.feeFlag=='1003006'">
                 {{scope.row.endTime|timeYMD}}
            </span>
            <span v-else>
              -
            </span>
          </template>
        </el-table-column> -->
        <!-- 状态 -->
        <!-- <el-table-column prop="stateName" :label="$t('lang.resourStatus')"></el-table-column> -->
        <el-table-column prop="payMethod" :label="$t('lang.lab_payMethod')"  width="100px">
            <template slot-scope="scope">
            <span>{{ scope.row.payMethod | payMethodName }}</span>
          </template>
        </el-table-column>
         <el-table-column label="发票号"  width="100px">
               <template slot-scope="scope">
                  {{scope.row.invoiceNo}}
               </template>
          </el-table-column>
          <el-table-column label="开票状态"  width="100px">
              <template slot-scope="scope">
                <span v-if="Number(scope.row.invoiceState) === 1">已开票</span>
                <span v-else-if="Number(scope.row.invoiceState) === 2">开票中</span>
                <span v-else-if="Number(scope.row.invoiceState) === 3">已冲红</span>
                <span v-else>{{scope.row.invoiceStateName}}</span>
              </template>
          </el-table-column>
          <el-table-column label="收据号"  width="150px">
            <template slot-scope="scope">
              {{scope.row.billNo}}
            </template>
          </el-table-column>
         <el-table-column label="缴款人">
               <template slot-scope="scope">
                  {{scope.row.personName}}
               </template>
            </el-table-column>
        <!-- 备注 -->
        <el-table-column prop="remark" :label="$t('lang.resourRemark')" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column v-if="isFeeManager===1 || (isRelationButton!=1)" prop="operation" :label="$t('lang.lab_operation')" width="320px">
          <template slot-scope="scope">
            <el-button @click="openBackFeeRegister(scope.row)" v-if="isBackButton&&isFeeManager==1" style="height: 0;line-height: 0;">{{"转款登记"}}</el-button>
            <el-button @click="payBack(scope.row)" v-if="isBackButton&&isFeeManager==1" style="height: 0;line-height: 0;">{{"转款"}}</el-button>
            <!-- <el-button @click="deleteFee(scope.row, 3)" v-if="isFeeManager===1 && scope.row.billNo" style="height: 0;line-height: 0;">{{"作废"}}</el-button> -->
            <el-button @click="printInvoice(scope.row)" v-if="scope.row.url&&scope.row.url!=''&&scope.row.state=='1400'&&isRelationButton!=1 && scope.row.state!='1800'" style="height: 0;line-height: 0;">{{"打票"}}</el-button>
            <!-- <el-button @click="print(scope.row)" v-if="scope.row.state=='1400'&&isRelationButton!=1 && scope.row.state!='1800'" style="height: 0;line-height: 0;">{{"打印收据"}}</el-button> -->
            <el-button @click="printReceipt(scope.row)" v-if="scope.row.state=='1400'&&isRelationButton!=1 && scope.row.state!='1800'" style="height: 0;line-height: 0;">{{"打印收据"}}</el-button>
            <el-button @click="refreshInvoicePdf(scope.row)" v-if="scope.row.state=='1400'&&isRelationButton!=1 && scope.row.state!='1800'" :disabled="!canRefreshInvoice(scope.row)" style="height: 0;line-height: 0;">{{"刷新"}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加页码 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50,1000]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
    <el-dialog :visible.sync="dialogShow" :close-on-click-modal="false" center top="130px" width="700px" :title="title"
      @closed="handleDialogClosed">
     <el-form :model="fileForm" ref="fileForm">
        <el-form-item label="文件上传/下载">
              <upload-morefiles ref="uploading" :accept='accept' upTypes='2' :fileList='filesList' :clears='clears'
                @outputFile="getFile" @removeFile='removeFile'></upload-morefiles>
          </el-form-item>
          <el-button class="detailbtn" type="primary" @click="saveFile('fileForm')">{{$t('lang.btn_save')}}</el-button>
     </el-form>
    </el-dialog>
    <!-- 合并开票对话框 -->
    <el-dialog 
      :visible.sync="invoicingDialogShow" 
      :close-on-click-modal="false" 
      center 
      top="130px" 
      width="700px" 
      title="合并开票"
      @closed="handleInvoicingDialogClosed">
      <el-form 
        :model="invoicingForm" 
        :rules="invoicingRules" 
        ref="invoicingForm" 
        :label-width="'140px'"
        :label-suffix="':'">
        <el-form-item label="开票类型" prop="billingType">
          <el-radio-group v-model="invoicingForm.billingType">
            <el-radio :label="2">普票</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="业主姓名" prop="ownerName" v-if="invoicingForm.billingType === 2">
          <el-input 
            v-model="invoicingForm.ownerName" 
            placeholder="业主姓名"
            >
          </el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码" v-if="invoicingForm.billingType === 2">
          <el-input
            v-model="invoicingForm.buyerTaxId"
            placeholder="请输入统一社会信用代码（选填）"
            maxlength="50">
          </el-input>
        </el-form-item>
         <!-- 专票区域 -->
        <template v-if="invoicingForm.billingType === 1">
          <el-form-item label="购方名称" prop="buyerName">
            <el-input 
              v-model="invoicingForm.buyerName" 
              placeholder="请输入购方名称"
              maxlength="100">
            </el-input>
          </el-form-item>
          <el-form-item label="购方纳税人识别号" prop="buyerTaxId">
            <el-input 
              v-model="invoicingForm.buyerTaxId" 
              placeholder="请输入购方纳税人识别号"
              maxlength="50">
            </el-input>
          </el-form-item>
          <el-form-item label="购方地址" prop="buyerAddress">
            <el-input 
              v-model="invoicingForm.buyerAddress" 
              placeholder="请输入购方地址"
              maxlength="200">
            </el-input>
          </el-form-item>
          <el-form-item label="购方电话" prop="buyerPhone">
            <el-input 
              v-model="invoicingForm.buyerPhone" 
              placeholder="请输入购方电话"
              maxlength="50">
            </el-input>
          </el-form-item>
          <el-form-item label="购方开户银行" prop="buyerBank">
            <el-input 
              v-model="invoicingForm.buyerBank" 
              placeholder="请输入购方开户银行"
              maxlength="100">
            </el-input>
          </el-form-item>
          <el-form-item label="购方银行账号" prop="buyerBankAccount">
            <el-input 
              v-model="invoicingForm.buyerBankAccount" 
              placeholder="请输入购方银行账号"
              maxlength="50">
            </el-input>
          </el-form-item>
          <el-form-item label="附件上传">
            <upload-morefiles ref="invoicingUpload" :accept="accept" upTypes="2" :fileList="invoicingFilesList"
              :clears="invoicingClears" @outputFile="getInvoicingFile" @removeFile="removeInvoicingFile">
            </upload-morefiles>
          </el-form-item>
        </template>
        <!-- 优惠政策标识=09 时展示租赁字段 -->
        <template v-if="showRentInfo">
          <el-form-item label="不动产地址" prop="rentId">
            <el-select
              v-model="invoicingForm.rentId"
              placeholder="请选择"
              filterable
              style="width:100%"
              @change="onRentAddressChange">
              <el-option
                v-for="item in rentAddressOptions"
                :key="item.id"
                :label="item.realPropertyAddress"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="详细地址" prop="detailAddress">
            <el-input
              v-model="invoicingForm.detailAddress"
              type="textarea"
              :rows="2"
              placeholder="必须包含 街、路、村、乡、镇、道 关键词"
              maxlength="120"
              show-word-limit>
            </el-input>
          </el-form-item>
          <el-form-item label="租赁开始日期" prop="rentStartDate">
            <el-date-picker
              v-model="invoicingForm.rentStartDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择开始日期"
              style="width:100%">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="租赁结束日期" prop="rentEndDate">
            <el-date-picker
              v-model="invoicingForm.rentEndDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择结束日期"
              style="width:100%">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="是否跨地(市)" prop="crossCityFlag">
            <el-select v-model="invoicingForm.crossCityFlag" placeholder="请选择" style="width:100%">
              <el-option label="否" value="0"></el-option>
              <el-option label="是" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="面积单位" prop="areaUnit">
            <el-select v-model="invoicingForm.areaUnit" placeholder="请选择面积单位" style="width:100%">
              <el-option v-for="item in areaUnitOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产权证号" prop="realPropertyCertificate">
            <el-input
              v-model="invoicingForm.realPropertyCertificate"
              placeholder="请输入产权证书/不动产权证号"
              maxlength="40">
            </el-input>
          </el-form-item>
        </template>
        <el-form-item label="备注">
          <el-input
            v-model="invoicingForm.invoiceRemark"
            type="textarea"
            :rows="2"
            placeholder="选填"
            maxlength="200"
            show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleInvoicingDialogClosed()">取消</el-button>
        <el-button type="primary" @click="submitInvoicing('invoicingForm')">确定</el-button>
      </div>
    </el-dialog>
    <!-- 转款登记 -->
    <el-dialog
      :visible.sync="backFeeRegisterDialogShow"
      :close-on-click-modal="false"
      center
      top="80px"
      width="720px"
      title="转款登记"
      @closed="handleBackFeeRegisterDialogClosed">
      <div style="margin-bottom: 10px; color: #606266;">
        实收金额：{{ backFeeRegisterReceivedAmount || '-' }}，已登记合计：{{ formatBackFeeRegisterSum() }}
      </div>
      <el-table :data="backFeeRegisterList" border max-height="400" class="wid100">
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column label="转款时间" min-width="200">
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.transferTime"
              type="datetime"
              value-format="timestamp"
              placeholder="请选择转款时间"
              style="width: 100%;"
              @change="markBackFeeRegisterDirty(scope.row)">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column label="转款金额" min-width="140">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.transferAmount"
              placeholder="请输入转款金额"
              @input="onTransferAmountInput(scope.row)">
            </el-input>
          </template>
        </el-table-column>
        <el-table-column label="登记人" min-width="120" prop="registrarName"></el-table-column>
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="saveBackFeeRegisterRow(scope.row)" v-if="scope.row._isDraft || scope.row._dirty">保存</el-button>
            <el-button type="text" @click="deleteBackFeeRegisterRow(scope.row, scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="appendBackFeeRegisterDraftRow">新增一行</el-button>
        <el-button @click="backFeeRegisterDialogShow = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
 import {
    excelDownload
  } from '../../../config/download.js'
/**
 *@ClassName:
 *@Description:
 *@author:xubz
 *@Copyright:格众科技
 *@date:
 */
 import uploadmoreFiles from '../../../components/upload_morefiles.vue'
// URL 只携带随机 token，真实收据号在同源窗口中短暂保存 5 分钟。
const RECEIPT_TRANSFER_PREFIX = 'feeReceiptPrint:'
const RECEIPT_TRANSFER_TTL = 5 * 60 * 1000
const FEE_ACTUAL_QUERY_FILTER_KEY = 'feeActualQuery_filter'

function createReceiptTransferToken() {
  if (!window.crypto || !window.crypto.getRandomValues) {
    return ''
  }
  const bytes = new Uint8Array(16)
  window.crypto.getRandomValues(bytes)
  return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('')
}

export default {
  name: 'feeActualQuery',
  data() {
    return {
      isBackFee:0,
      isBack: 0,
      isBackButton:0,
      isFeeManager:0,
      isRelationButton:this.$store.getters.isRelationButton,
      switchValue:false,
      searchFeeName:'',
      fileForm:{},
      clears: false, // 清空按钮
      accept: '*.*',
      fileList:[],
      filesList:[],
      title: this.$i18n.t('lang.lab_myCollection'), // 弹框标题
      dialogShow: false, // 弹框显示
      multipleSelection: [], // 多选框
      editableTabs: [], // tabs列表
      startTime: '',
      endTime: '',
      houseId: '', // 楼层绑定值
      floorList: [], // 楼层下拉列表
      unitid: '', // 单元绑定值
      unitList: [], // 单元下拉列表
      roomid: '', // 房间绑定值
      roomList: [], // 房间下拉列表
      user: '0', // 身份
      tag: '0', // 标签
      keyword: '', // 手机或序号内容input
      pageCount: 0, // 总页数
      pageNo: 1, // 第几页
      pageSize: 10, // 每页显示数
      tableData: [], // 列表数组
      type: 1, // 楼号单元号房间号区分
      parentId: '',
      gardenId: '', // 小区编号
      Identitys: this.$i18n.t('lang.APPHOUSEHOLDMANAGE.USERTYPE'), // 身份列表
      receiveArrearSelects: this.$i18n.t('lang.lab_receiveArrearSelect'), // 标签列表
      appHouseholdManageListcheckbox:true,// 是否隐藏复选框
      receiveAmountCount: '',
      revAmountCount: '',
      paidAmountCount: '',
      receiveArrearSelect: '0',

      // -------------------------------
      payMethodList: this.$i18n.t('lang.payMethodList'),
      expands: [],
      expandata: [],
      expandataFlag: false,
      receivedAmountCount: '',
      isExpand: false,
      payMethod: '',
      // 合并开票对话框相关
      invoicingDialogShow: false, // 合并开票对话框显示/隐藏
      invoicingFileList: [],
      invoicingFilesList: [],
      invoicingClears: false,
      invoicingForm: {
        billingType: 2, // 开票类型：1 专票已隐藏，默认普票(2)
        ownerName: '', // 业主姓名
        buyerName: '', // 购方名称
        buyerTaxId: '', // 购方纳税人识别号
        buyerAddress: '', // 购方地址
        buyerPhone: '', // 购方电话
        buyerBank: '', // 购方开户银行
        buyerBankAccount: '', // 购方银行账号
        invoiceRemark: '', // 发票备注（追加到项目名称_楼栋-房号后）
        rentId: '',
        realPropertyAddress: '',
        detailAddress: '',
        rentStartDate: '',
        rentEndDate: '',
        crossCityFlag: '0',
        areaUnit: '2',
        realPropertyCertificate: '',
      },
      showRentInfo: false,
      rentAddressOptions: [],
      areaUnitOptions: [
        { value: '1', label: '平方千米' },
        { value: '2', label: '平方米' },
        { value: '3', label: '公顷' },
        { value: '4', label: '亩' },
        { value: '5', label: 'h㎡' },
        { value: '6', label: 'km' },
        { value: '7', label: 'm' },
        { value: '8', label: '码' }
      ],
      backFeeRegisterDialogShow: false,
      backFeeRegisterList: [],
      backFeeRegisterGardenId: '',
      backFeeRegisterDetailId: '',
      backFeeRegisterReceivedAmount: '',
      defaultRegistrarName: '',
      invoicingRules: {
        billingType: [
          {
            required: true,
            message: '请选择开票类型',
            trigger: 'change'
          }
        ],
        ownerName: [
          {
            required: true,
            message: '业主姓名不能为空',
            trigger: 'blur'
          }
        ],
        buyerTaxId: [
          {
            required: true,
            message: '请输入购方纳税人识别号',
            trigger: 'blur'
          }
        ],
        buyerAddress: [
          {
            required: true,
            message: '请输入购方地址',
            trigger: 'blur'
          }
        ],
        buyerPhone: [
          {
            required: true,
            message: '请输入购方电话',
            trigger: 'blur'
          }
        ],
        buyerBank: [
          {
            required: true,
            message: '请输入购方开户银行',
            trigger: 'blur'
          }
        ],
        buyerBankAccount: [
          {
            required: true,
            message: '请输入购方银行账号',
            trigger: 'blur'
          }
        ],
        realPropertyAddress: [
          { required: true, message: '请选择不动产地址', trigger: 'change' }
        ],
        detailAddress: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        rentStartDate: [
          { required: true, message: '请选择租赁开始日期', trigger: 'change' }
        ],
        rentEndDate: [
          { required: true, message: '请选择租赁结束日期', trigger: 'change' }
        ],
        crossCityFlag: [
          { required: true, message: '请选择是否跨地(市)', trigger: 'change' }
        ],
        areaUnit: [
          { required: true, message: '请选择面积单位', trigger: 'change' }
        ],
        rentId: [
          { required: true, message: '请选择不动产地址', trigger: 'change' }
        ],
      },
    }
  },
   components: {
      'upload-morefiles': uploadmoreFiles
    },
  created() {
    this.isFeeManager = this.$store.getters.isFeeManager
    // 小区编号
    this.gardenId = this.$store.getters.gardenId
    this.initPageWithFilterCache()
  },
  beforeRouteLeave(to, from, next) {
    this.saveFilterCache()
    next()
  },
  deactivated() {
    this.saveFilterCache()
  },
  // 监听改变小区编号
  watch: {
    '$store.state.allGardenId': function (newFlag, oldFlag) {
      this.gardenId = this.$store.state.allGardenId
      this.gardenChange()
    },
    // 监听开票类型变化
    'invoicingForm.billingType': function (newVal) {
      if (this.$refs.invoicingForm) {
        // 清除所有字段的验证状态
        this.$refs.invoicingForm.clearValidate()
      }
    },
    // '$store.state.tabList': function (newFlag, oldFlag) {
    //   this.editableTabs = this.$store.getters.getTabList
    // },
  },
  methods: {
    saveFilterCache() {
      try {
        const payload = {
          gardenId: this.gardenId,
          startTime: this.startTime,
          endTime: this.endTime,
          houseId: this.houseId,
          unitid: this.unitid,
          roomid: this.roomid,
          payMethod: this.payMethod,
          searchFeeName: this.searchFeeName,
          keyword: this.keyword
        }
        window.sessionStorage.setItem(FEE_ACTUAL_QUERY_FILTER_KEY, JSON.stringify(payload))
      } catch (e) {
        console.warn('save feeActualQuery filter fail', e)
      }
    },
    restoreFilterCache() {
      try {
        const raw = window.sessionStorage.getItem(FEE_ACTUAL_QUERY_FILTER_KEY)
        if (!raw) {
          return false
        }
        const data = JSON.parse(raw)
        if (data.gardenId == null || String(data.gardenId) !== String(this.gardenId)) {
          return false
        }
        this.startTime = data.startTime || ''
        this.endTime = data.endTime || ''
        this.houseId = data.houseId || ''
        this.unitid = data.unitid || ''
        this.roomid = data.roomid || ''
        this.payMethod = data.payMethod || ''
        this.searchFeeName = data.searchFeeName || ''
        this.keyword = data.keyword || ''
        return true
      } catch (e) {
        console.warn('restore feeActualQuery filter fail', e)
        return false
      }
    },
    async initPageWithFilterCache() {
      const restored = this.restoreFilterCache()
      if (!restored) {
        this.getDatePicker()
      }
      let loading = this.$loading()
      try {
        this.type = 1
        await this.fetchGardenGrids(this.gardenId)
        if (restored && this.houseId) {
          this.type = 2
          await this.fetchGardenGrids(this.houseId)
        }
        if (restored && this.unitid) {
          this.type = 3
          await this.fetchGardenGrids(this.unitid)
        }
      } catch (error) {
        this.$message.error(error)
      } finally {
        loading.close()
      }
      this.feeDetailHistory()
    },
    openBackFeeRegister(row) {
      if (!row || !row.detailId) {
        this.$message.warning('缺少缴费明细ID，无法打开转款登记')
        return
      }
      const gardenId = row.gardenId || this.gardenId
      if (!gardenId) {
        this.$message.warning('请先选择小区')
        return
      }
      this.backFeeRegisterGardenId = gardenId
      this.backFeeRegisterDetailId = row.detailId
      this.backFeeRegisterReceivedAmount = row.receivedAmount
      const userData = this.$store.getters.userData || {}
      this.defaultRegistrarName = this.$store.getters.nickName || userData.userName || userData.name || ''
      this.backFeeRegisterDialogShow = true
      this.loadBackFeeRegisterList()
    },
    loadBackFeeRegisterList() {
      const loading = this.$loading()
      this.$get(`/feeBackFeeRegisterAll`, {
        gardenId: this.backFeeRegisterGardenId,
        detailId: this.backFeeRegisterDetailId
      }).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            this.backFeeRegisterList = (res.list || []).map(item => {
              return Object.assign({}, item, {
                transferTime: this.normalizeTransferTimeForPicker(item.transferTime),
                _isDraft: false,
                _dirty: false
              })
            })
            this.ensureBackFeeRegisterDraftRow()
          }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    createBackFeeRegisterDraftRow() {
      return {
        gardenId: this.backFeeRegisterGardenId,
        detailId: this.backFeeRegisterDetailId,
        transferTime: '',
        transferAmount: '',
        registrarName: this.defaultRegistrarName,
        _isDraft: true,
        _dirty: true
      }
    },
    ensureBackFeeRegisterDraftRow() {
      const hasDraft = this.backFeeRegisterList.some(item => item._isDraft)
      if (!hasDraft) {
        this.backFeeRegisterList.push(this.createBackFeeRegisterDraftRow())
      }
    },
    appendBackFeeRegisterDraftRow() {
      this.backFeeRegisterList.push(this.createBackFeeRegisterDraftRow())
    },
    markBackFeeRegisterDirty(row) {
      if (!row._isDraft) {
        this.$set(row, '_dirty', true)
      }
    },
    normalizeTransferTimeForPicker(value) {
      if (value === null || value === undefined || value === '') {
        return ''
      }
      if (typeof value === 'number') {
        return value
      }
      if (typeof value === 'string' && /^\d+$/.test(value)) {
        return Number(value)
      }
      const date = new Date(value)
      return Number.isNaN(date.getTime()) ? '' : date.getTime()
    },
    onTransferAmountInput(row) {
      this.markBackFeeRegisterDirty(row)
    },
    toAmountCents(value) {
      if (value === '' || value === null || value === undefined) {
        return null
      }
      const amount = Number(value)
      if (Number.isNaN(amount)) {
        return null
      }
      return Math.round(amount * 100)
    },
    formatAmountFromCents(cents) {
      if (cents === null || cents === undefined) {
        return '0.00'
      }
      return (cents / 100).toFixed(2)
    },
    formatBackFeeRegisterSum() {
      return this.formatAmountFromCents(this.getSavedRegisterAmountCents())
    },
    getSavedRegisterAmountCents(excludeRow) {
      let totalCents = 0
      this.backFeeRegisterList.forEach(item => {
        if (!item || item === excludeRow || !item.id) {
          return
        }
        const cents = this.toAmountCents(item.transferAmount)
        if (cents !== null) {
          totalCents += cents
        }
      })
      return totalCents
    },
    validateBackFeeRegisterAmount(row) {
      const currentCents = this.toAmountCents(row.transferAmount)
      if (currentCents === null) {
        this.$message.warning('请输入有效转款金额')
        return false
      }
      if (currentCents <= 0) {
        this.$message.warning('转款金额必须大于0')
        return false
      }
      const receivedCents = this.toAmountCents(this.backFeeRegisterReceivedAmount)
      if (receivedCents === null || receivedCents <= 0) {
        this.$message.warning('实收金额无效，无法登记转款')
        return false
      }
      if (currentCents > receivedCents) {
        this.$message.warning('转款金额不得大于实收金额')
        return false
      }
      const totalCents = this.getSavedRegisterAmountCents(row) + currentCents
      if (totalCents > receivedCents) {
        this.$message.warning('累计转款金额不得大于实收金额')
        return false
      }
      return true
    },
    findLatestTransferTime(list) {
      let latest = 0
      ;(list || []).forEach(item => {
        const time = this.normalizeTransferTimeForPicker(item && item.transferTime)
        if (time && time > latest) {
          latest = time
        }
      })
      return latest || ''
    },
    saveBackFeeRegisterRow(row) {
      if (!row.transferTime) {
        this.$message.warning('请选择转款时间')
        return
      }
      if (row.transferAmount === '' || row.transferAmount === null || row.transferAmount === undefined) {
        this.$message.warning('请输入转款金额')
        return
      }
      if (!this.validateBackFeeRegisterAmount(row)) {
        return
      }
      const params = {
        gardenId: this.backFeeRegisterGardenId,
        detailId: this.backFeeRegisterDetailId,
        transferTime: row.transferTime,
        transferAmount: row.transferAmount,
        registrarName: row.registrarName || this.defaultRegistrarName
      }
      const loading = this.$loading()
      if (row._isDraft || !row.id) {
        this.$post('/feeBackFeeRegister', params).then(
          (res) => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message.success(this.$i18n.t('lang.lab_save_success'))
              this.loadBackFeeRegisterList()
            } else {
              this.$message.error(res.errMsg || '保存失败')
            }
          },
          (error) => {
            loading.close()
            this.$message.error(error)
          }
        )
      } else {
        this.$patch(`/feeBackFeeRegister/${row.id}`, params).then(
          (res) => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message.success(this.$i18n.t('lang.lab_save_success'))
              row._dirty = false
              this.loadBackFeeRegisterList()
            } else {
              this.$message.error(res.errMsg || '保存失败')
            }
          },
          (error) => {
            loading.close()
            this.$message.error(error)
          }
        )
      }
    },
    deleteBackFeeRegisterRow(row, index) {
      if (!row.id) {
        this.backFeeRegisterList.splice(index, 1)
        this.ensureBackFeeRegisterDraftRow()
        return
      }
      this.$confirm('确定删除该转款登记记录吗？', this.$i18n.t('lang.lab_prompt'), {
        confirmButtonText: this.$i18n.t('lang.btn_confirm'),
        cancelButtonText: this.$i18n.t('lang.btn_cancel'),
        type: 'warning'
      }).then(() => {
        const loading = this.$loading()
        this.$delete(`/feeBackFeeRegister/${row.id}`).then(
          (res) => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message.success('删除成功')
              this.loadBackFeeRegisterList()
            } else {
              this.$message.error(res.errMsg || '删除失败')
            }
          },
          (error) => {
            loading.close()
            this.$message.error(error)
          }
        )
      }).catch(() => {})
    },
    handleBackFeeRegisterDialogClosed() {
      this.backFeeRegisterList = []
      this.backFeeRegisterGardenId = ''
      this.backFeeRegisterDetailId = ''
      this.backFeeRegisterReceivedAmount = ''
    },
    payBack(row){
      if (!row || !row.detailId) {
        this.$message.warning('缺少缴费明细ID，无法转款')
        return
      }
      const gardenId = row.gardenId || this.gardenId
      const receivedCents = this.toAmountCents(row.receivedAmount)
      if (receivedCents === null || receivedCents <= 0) {
        this.$message.warning('实收金额无效，无法转款')
        return
      }
      const loading = this.$loading()
      this.$get(`/feeBackFeeRegisterAll`, {
        gardenId: gardenId,
        detailId: row.detailId
      }).then(
        (res) => {
          loading.close()
          if (!(res && res.errCode === 0)) {
            this.$message.error((res && res.errMsg) || '查询转款登记失败')
            return
          }
          const list = res.list || []
          if (!list.length) {
            this.$message.warning('请先进行转款登记')
            return
          }
          let totalCents = 0
          list.forEach(item => {
            const cents = this.toAmountCents(item.transferAmount)
            if (cents !== null) {
              totalCents += cents
            }
          })
          if (totalCents < receivedCents) {
            this.$message.warning('转款登记累计金额小于实收金额，不允许转款')
            return
          }
          if (totalCents > receivedCents) {
            this.$message.warning('转款登记累计金额不得大于实收金额')
            return
          }
          const latestTransferTime = this.findLatestTransferTime(list)
          if (!latestTransferTime) {
            this.$message.warning('转款登记缺少转款时间，无法更新缴款时间')
            return
          }
          this.$confirm(this.$i18n.t('lang.lab_isSaveFee'),
              this.$i18n.t('lang.lab_prompt'), {
                confirmButtonText: this.$i18n.t('lang.btn_confirm'),
                cancelButtonText: this.$i18n.t('lang.btn_cancel'),
                type: 'warning'
              }).then(() => {
                let params = {
                        createTimeLong: latestTransferTime,
                        isBackFee: 2
                      }
                      let saveLoading = this.$loading()
                    this.$patch(`/updatePayFeeDetailHistory/${row.detailId}`, params).then(
                        (saveRes) => {
                          saveLoading.close()
                          if (saveRes && saveRes.errCode === 0) {
                            this.$message.success(this.$i18n.t('lang.lab_save_success'))
                            this.isPopupPage = false
                            this.feeDetailHistory()
                          } else {
                            this.$message.error((saveRes && saveRes.errMsg) || '转款失败')
                          }
                        },
                        (error) => {
                          saveLoading.close()
                          this.$message.error(error)
                          this.isPopupPage = false
                        }
                      )
              }).catch(() => {})
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    printInvoice(row) {
      window.open(row.url)
    },
    // 打印：与 feeProperty.vue 相同，用当前行构建 params 并打开打印页
    print(row) {
      if (!row.billNo || row.billNo.trim() === '') {
        this.$message.warning('该条记录未开收据，无法打印')
        return
      }
      const params = {
        gardenId: row.gardenId,
        receiptNumber: row.receiptNumber || '',
        billNo: row.billNo || '',
        ownerName: row.childName || row.ownerName || '',
        roomDescribe: [row.houseName, row.unitName, row.roomName].filter(Boolean).join('')
      }
      const p = encodeURIComponent(JSON.stringify(params))
      const r = encodeURIComponent(JSON.stringify(row))
      window.open("https://zhwyjk.kmyhwy.cn/feePrint?params="+p+"&row="+r,'_blank')
      // window.open('http://localhost:8082?params=' + p + '&row=' + r, '_blank')
    },
    // 打印收据-杜
    printReceipt(row) {
      if (!row.billNo || row.billNo.trim() === '') {
        this.$message.warning('该条记录未开收据，无法打印')
        return
      }
      const receiptNumber = row && row.receiptNumber ? String(row.receiptNumber).trim() : ''
      if (!receiptNumber) {
        this.$message.warning('该条记录缺少收据标识，无法打印')
        return
      }
      const gardenId = String((row && row.gardenId) || this.gardenId || '').trim()
      const transferToken = createReceiptTransferToken()
      if (!transferToken) {
        this.$message.error('当前浏览器不支持安全传参，无法打开收据')
        return
      }
      const storageKey = `${RECEIPT_TRANSFER_PREFIX}${transferToken}`
      const transferPayload = JSON.stringify({
        transferToken,
        receiptNumber,
        gardenId,
        createdAt: Date.now()
      })
      // Storage 仅作为 window.name 传递失败时的同源兜底。
      let transferSaved = false
      try {
        window.sessionStorage.setItem(storageKey, transferPayload)
        transferSaved = true
      } catch (error) {
        // sessionStorage 不可用时继续尝试 localStorage 兜底。
      }
      try {
        window.localStorage.setItem(storageKey, transferPayload)
        transferSaved = true
      } catch (error) {
        // localStorage 不可用时依赖 sessionStorage。
      }
      if (!transferSaved) {
        this.$message.error('安全传参失败，请重新打开收据')
        return
      }
      const routeData = this.$router.resolve({
        name: 'feeReceiptPrint',
        query: { token: transferToken }
      })
      const printWindow = window.open('', '_blank')
      if (!printWindow) {
        window.sessionStorage.removeItem(storageKey)
        window.localStorage.removeItem(storageKey)
        this.$message.warning('打印页面被浏览器拦截，请允许打开新窗口')
        return
      }
      const routeLink = document.createElement('a')
      routeLink.href = routeData.href
      try {
        // 先写入新窗口，再跳转到打印路由，避免收据号出现在地址栏。
        printWindow.name = transferPayload
        printWindow.location.replace(routeLink.href)
      } catch (error) {
        window.sessionStorage.removeItem(storageKey)
        window.localStorage.removeItem(storageKey)
        printWindow.close()
        this.$message.error('安全传参失败，请重新打开收据')
        return
      }
      window.setTimeout(() => {
        window.sessionStorage.removeItem(storageKey)
        window.localStorage.removeItem(storageKey)
      }, RECEIPT_TRANSFER_TTL)
    },
    canRefreshInvoice(row) {
      const invoiceState = Number(row.invoiceState)
      if (!row.invoiceDetailId || (invoiceState !== 1 && invoiceState !== 3)) {
        return false
      }
      const invoiceNo = row.invoiceNo ? String(row.invoiceNo).trim() : ''
      const url = row.url ? String(row.url).trim() : ''
      // 与后端 refreshInvoicePdf 一致：发票号、PDF 地址任一缺失时可刷新
      return invoiceNo === '' || url === ''
    },
    refreshInvoicePdf(row) {
      if (!this.canRefreshInvoice(row)) {
        return
      }
      const loading = this.$loading()
      const params = {
        detailId: row.detailId,
        gardenId: row.gardenId,
        invoiceDetailId: row.invoiceDetailId
      }
      this.$post('/refreshInvoicePdf', params).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.$message.success('刷新成功')
            this.feeDetailHistory()
          } else {
            this.$message.error((res && res.errMsg) || '刷新失败')
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 作废/删除/红冲：与 feeProperty.vue 相同，red=3 表示作废
    deleteFee(row, red) {
      if (parseInt(row.payMethod) > 6) {
        return this.$message.error('线上缴费不能进行该操作')
      }
      if (red === 3) {
        if (!row.billNo || row.billNo.trim() === '') {
          this.$message.warning('该数据不存在收据编号，不能进行作废')
          return
        }
      }
      row['red'] = red
      this.executeDeleteFee(row, red)
    },
    executeDeleteFee(row, red) {
      let loading = this.$loading()
      this.$confirm('是否确认该操作？', this.$i18n.t('lang.lab_prompt'), {
        confirmButtonText: this.$i18n.t('lang.btn_confirm'),
        cancelButtonText: this.$i18n.t('lang.btn_cancel'),
        type: 'warning'
      })
        .then(() => {
          row['feeState'] = '1'
          this.$postJson(`/processFeePayHistoryReturnOrDelete/`, row).then(
            (res) => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_del_success'))
                this.feeDetailHistory()
              }
            },
            (error) => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    },
    isRedFlushedReinvoiceable(item) {
      if (!item || Number(item.invoiceState) !== 3) {
        return false
      }
      const invoiceDetailId = item.invoiceDetailId
      return invoiceDetailId != null && String(invoiceDetailId).trim() !== ''
    },
    combinedInvoicing(){
      console.log('multipleSelection',this.multipleSelection)  
      // 检查是否有选中的数据
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$message.warning('请先选择要合并开票的数据')
        return
      }
      // 已冲红且关联红票的记录允许重新开蓝票，其余有发票号的仍拦截
      const hasInvoiceNo = this.multipleSelection.some(item => {
        if (this.isRedFlushedReinvoiceable(item)) {
          return false
        }
        return item.invoiceNo != null && String(item.invoiceNo).trim() !== ''
      })
      if (hasInvoiceNo) {
        this.$message.warning('选中的数据中已存在发票编号，不能进行合并开票')
        return
      }
      const hasInvalidInvoiceState = this.multipleSelection.some(item => {
        if (this.isRedFlushedReinvoiceable(item)) {
          return false
        }
        const state = Number(item.invoiceState)
        return state === 1 || state === 2
      })
      if (hasInvalidInvoiceState) {
        this.$message.warning('选中的数据中包含开票中或已开票记录，不能进行合并开票')
        return
      }
      // 检查选中的数据rid是否相同
      const firstRid =this.multipleSelection[0].rchId
      // 检查所有选中数据的rid是否相同
      const first = this.multipleSelection[0] || {}
      const hasDifferentRid = this.multipleSelection.every(item=>item.ownerName===first.ownerName && item.mobile===first.mobile)
      if (!hasDifferentRid) {
        this.$message.warning('选中的数据不是相同业主,不能进行合并开票')
        return
      }
      // 打开合并开票对话框
      this.invoicingDialogShow = true
      // 重置表单
      this.resetInvoicingForm()
      // 优惠政策标识=09 时展示不动产经营租赁信息
      this.showRentInfo = this.multipleSelection.some(item => String(item.favouredPolicyFlag) === '09')
      // 设置业主姓名（从选中数据中获取）
      this.invoicingForm.ownerName = this.multipleSelection[0].childName || this.multipleSelection[0].ownerName || ''
      // 设置购方信息（专票时使用）
      this.invoicingForm.buyerName = this.multipleSelection[0].BuyerName || ''
      this.invoicingForm.buyerTaxId = this.multipleSelection[0].BuyerTaxId || ''
      this.invoicingForm.buyerAddress = this.multipleSelection[0].BuyerAddress || ''
      this.invoicingForm.buyerPhone = this.multipleSelection[0].BuyerPhone || ''
      this.invoicingForm.buyerBank = this.multipleSelection[0].BuyerBank || ''
      this.invoicingForm.buyerBankAccount = this.multipleSelection[0].BuyerBankAccount || ''
      if (this.showRentInfo) {
        this.loadRentAddressOptions()
      }
    },
      // 重置合并开票表单
      resetInvoicingForm() {
        this.invoicingForm = {
          billingType: 2, // 开票类型：1 专票已隐藏，默认普票(2)
          ownerName: '',
          buyerName: '',
          buyerTaxId: '',
          buyerAddress: '',
          buyerPhone: '',
          buyerBank: '',
          buyerBankAccount: '',
          invoiceRemark: '',
          rentId: '',
          realPropertyAddress: '',
          detailAddress: '',
          rentStartDate: '',
          rentEndDate: '',
          crossCityFlag: '0',
          areaUnit: '2',
          realPropertyCertificate: '',
        }
        this.showRentInfo = false
        this.rentAddressOptions = []
        this.invoicingFileList = []
        this.invoicingFilesList = []
        this.invoicingClears = false
      // 清除表单验证
      if (this.$refs.invoicingForm) {
        this.$refs.invoicingForm.clearValidate()
      }
    },
    loadRentAddressOptions() {
      const roomId = this.multipleSelection[0] && this.multipleSelection[0].roomId
      if (!roomId) {
        this.rentAddressOptions = []
        this.$message.warning('未获取到房间信息，无法加载不动产地址')
        return
      }
      this.$get(`/feeRealPropertyRentList?roomId=${roomId}&pageNo=1&pageSize=999`).then(
        res => {
          if (res && res.errCode === 0) {
            this.rentAddressOptions = res.list || []
            if (!this.rentAddressOptions.length) {
              this.$message.warning('该房间暂无租赁信息，请先在原始住户中添加')
            }
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    onRentAddressChange(rentId) {
      const matched = this.rentAddressOptions.find(item => String(item.id) === String(rentId))
      if (!matched) {
        return
      }
      this.invoicingForm.realPropertyAddress = matched.realPropertyAddress || ''
      this.invoicingForm.detailAddress = matched.detailAddress || ''
      this.invoicingForm.rentStartDate = matched.rentStartDate || ''
      this.invoicingForm.rentEndDate = matched.rentEndDate || ''
      this.invoicingForm.crossCityFlag = matched.crossCityFlag != null ? String(matched.crossCityFlag) : '0'
      this.invoicingForm.areaUnit = matched.areaUnit != null ? String(matched.areaUnit) : '2'
      this.invoicingForm.realPropertyCertificate = matched.realPropertyCertificate || ''
    },
    getInvoicingFile(e, f) {
      this.invoicingFileList.push({
        name: f,
        url: e
      })
    },
    removeInvoicingFile(e) {
      if (e === true) {
        this.invoicingFileList = []
        this.invoicingFilesList = []
        return
      }
      let list = []
      for (let i = 0; i < this.invoicingFileList.length; i++) {
        if (this.invoicingFileList[i].url !== e) {
          list.push(this.invoicingFileList[i])
        }
      }
      this.invoicingFileList = list
      this.invoicingFilesList = JSON.parse(JSON.stringify(list))
    },
    // 处理合并开票对话框关闭
    handleInvoicingDialogClosed() {
      this.invoicingDialogShow = false
      this.resetInvoicingForm()
    },
    // 提交合并开票表单
    submitInvoicing(formName) {
      // 动态调整验证规则：根据开票类型验证不同字段
      if (this.invoicingForm.billingType === 1) {
        // 专票(1)：所有购方信息字段必填，业主姓名不验证
        this.invoicingRules.buyerTaxId[0].required = true
        this.invoicingRules.buyerAddress[0].required = true
        this.invoicingRules.buyerPhone[0].required = true
        this.invoicingRules.buyerBank[0].required = true
        this.invoicingRules.buyerBankAccount[0].required = true
        this.invoicingRules.ownerName[0].required = false
      } else {
        // 普票(2)：业主姓名必填，购方信息字段不验证
        this.invoicingRules.ownerName[0].required = true
        this.invoicingRules.buyerTaxId[0].required = false
        this.invoicingRules.buyerAddress[0].required = false
        this.invoicingRules.buyerPhone[0].required = false
        this.invoicingRules.buyerBank[0].required = false
        this.invoicingRules.buyerBankAccount[0].required = false
      }
      // 不动产租赁信息：仅 favouredPolicyFlag=09 时必填
      const rentRequired = !!this.showRentInfo
      this.invoicingRules.rentId[0].required = rentRequired
      this.invoicingRules.realPropertyAddress[0].required = false
      this.invoicingRules.detailAddress[0].required = rentRequired
      this.invoicingRules.rentStartDate[0].required = rentRequired
      this.invoicingRules.rentEndDate[0].required = rentRequired
      this.invoicingRules.crossCityFlag[0].required = rentRequired
      this.invoicingRules.areaUnit[0].required = rentRequired
      
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const hasInvalidInvoiceState = this.multipleSelection.some(item => {
            if (this.isRedFlushedReinvoiceable(item)) {
              return false
            }
            const state = Number(item.invoiceState)
            return state === 1 || state === 2
          })
          if (hasInvalidInvoiceState) {
            this.$message.warning('选中的数据中包含开票中或已开票记录，不能进行合并开票')
            return
          }
          // 表单验证通过，这里可以调用API提交数据
          console.log('选中的数据：', this.multipleSelection)
          console.log('表单数据：', this.invoicingForm)
          
          // 当isBackFee为false且billingType==1时，在submitInvoicing方法中校验只能选择一条数据
          if (!this.isBackFee && this.invoicingForm.billingType === 1) {
            if (this.multipleSelection.length > 1) {
              this.$message.warning('只能选择一条数据进行开票')
              return
            }
          }
          
          // 判断是否需要弹出确认提示窗
          let needConfirm = false
          let apiUrl = '/combinedInvoicing'
          if (this.isBackFee || (!this.isBackFee && this.invoicingForm.billingType === 1)) {
            apiUrl = '/combinedInvoicingMaintain'
            needConfirm = true
          }
          
          // 如果需要确认，先弹出确认提示窗
          if (needConfirm) {
            this.$confirm('需要发起审批确认后系统会自动完成开票，之后下载PDF', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'info'
            }).then(() => {
              // 用户确认后调用API
              this.callInvoicingApi(apiUrl)
            }).catch(() => {
              // 用户取消，不做任何操作
            })
          } else {
            // 不需要确认，直接调用API
            this.callInvoicingApi(apiUrl)
          }
          
        } else {
          this.$message.error('请填写完整的表单信息')
          return false
        }
      })
    },
    // 调用开票API
    callInvoicingApi(apiUrl) {
      let loading = this.$loading()
      let params = {
        jsonArrayData: JSON.stringify(this.multipleSelection),
        ownerName: this.invoicingForm.ownerName,
        billingType: this.invoicingForm.billingType,
        buyerName: this.invoicingForm.buyerName,
        buyerTaxId: this.invoicingForm.buyerTaxId,
        buyerAddress: this.invoicingForm.buyerAddress,
        buyerPhone: this.invoicingForm.buyerPhone,
        buyerBank: this.invoicingForm.buyerBank,
        buyerBankAccount: this.invoicingForm.buyerBankAccount,
        invoiceRemark: this.invoicingForm.invoiceRemark,
      }
      if (this.showRentInfo) {
        if (this.invoicingForm.rentStartDate && this.invoicingForm.rentEndDate
          && this.invoicingForm.rentStartDate > this.invoicingForm.rentEndDate) {
          loading.close()
          this.$message.warning('租赁开始日期不能晚于结束日期')
          return
        }
        params.rentInfo = JSON.stringify({
          realPropertyAddress: this.invoicingForm.realPropertyAddress,
          detailAddress: this.invoicingForm.detailAddress,
          rentStartDate: this.invoicingForm.rentStartDate,
          rentEndDate: this.invoicingForm.rentEndDate,
          crossCityFlag: this.invoicingForm.crossCityFlag,
          areaUnit: this.invoicingForm.areaUnit,
          realPropertyCertificate: this.invoicingForm.realPropertyCertificate || ''
        })
      }
      if (apiUrl === '/combinedInvoicingMaintain' && this.invoicingFileList.length > 0) {
        const fileUrls = []
        for (let i = 0; i < this.invoicingFileList.length; i++) {
          const url = this.invoicingFileList[i].url
          if (url && url.indexOf('blob') === -1) {
            fileUrls.push(url)
          }
        }
        if (fileUrls.length > 0) {
          params.files = fileUrls.join(',')
        }
      }
      this.$post(apiUrl, params).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            // 如果是调用/combinedInvoicingMaintain，显示"创建工单成功"
            if (apiUrl === '/combinedInvoicingMaintain') {
              this.$message.success('创建工单成功')
            } else {
              this.$message.success('合并开票成功')
            }
            this.handleInvoicingDialogClosed()
            this.feeDetailHistory() // 刷新列表
          } else {
            this.$message.error(res.errMsg || '操作失败')
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 合并开收据方法
    combinedReceiptNumber(){
      console.log('multipleSelection',this.multipleSelection)  
      // 检查是否有选中的数据
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$message.warning('请先选择要合并开收据的数据')
        return
      }
      // 检查所选中数据中有billNo时不能开收据
      const hasBillNo = this.multipleSelection.some(item => item.billNo && item.billNo.trim() !== '')
      if (hasBillNo) {
        this.$message.warning('选中的数据中已存在收据编号，不能进行合并开收据')
        return
      }
      // 检查选中的数据rid是否相同
      const firstRid =this.multipleSelection[0].rchId
      // 检查所有选中数据的rid是否相同
      const first = this.multipleSelection[0] || {}
      const hasDifferentRid = this.multipleSelection.every(item=>item.ownerName===first.ownerName && item.mobile===first.mobile)
      if (!hasDifferentRid) {
        this.$message.warning('选中的数据不是相同业主,不能进行合并开收据')
        return
      }
      // 确认后再调用后端API
      this.$confirm('确定要对该条数据开收据吗？', this.$i18n.t('lang.lab_prompt'), {
        confirmButtonText: this.$i18n.t('lang.btn_confirm'),
        cancelButtonText: this.$i18n.t('lang.btn_cancel'),
        type: 'warning'
      }).then(() => {
        let loading = this.$loading()
        let params = {
          jsonArrayData: JSON.stringify(this.multipleSelection),
          gardenId: this.multipleSelection[0].gardenId || null
        }
        this.$post('/combinedReceiptNumber', params).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message.success('合并开收据成功')
              this.feeDetailHistory() // 刷新列表
            } else {
              this.$message.error(res.errMsg || '合并开收据失败')
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      }).catch(() => {
        this.$message({ type: 'info', message: this.$i18n.t('lang.lab_del_can') })
      })
    },
    excelDownloadClick() {
        if (navigator.onLine) {
          // Excel表头
          const tHeader = [
            this.$i18n.t('lang.lab_username'),
            this.$i18n.t('lang.lab_phone'),
            this.$i18n.t('lang.lab_village'),
            this.$i18n.t('lang.lab_buildingnum'),
            this.$i18n.t('lang.resourUnit'),
            this.$i18n.t('lang.lab_roomnum'),
            this.$i18n.t('lang.lab_preHouseholdArea'),
            this.$i18n.t('lang.lab_feeName'),

            this.$i18n.t('lang.lab_receivedAmountH'),
            this.$i18n.t('lang.lab_createFeeHTime'),

            this.$i18n.t('lang.lab_startFeeHTime'),
            this.$i18n.t('lang.lab_endFeeHTime'),
            this.$i18n.t('lang.resourStatus'),
            this.$i18n.t('lang.lab_payMethod'),
            this.$i18n.t('lang.resourRemark'),
          ]
          let newArr = []
          let createTime = ''
          let startTime = ''
          let endTime = ''
          let payMethod = ''
          if (this.tableData.length > 0) {
            for (let i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].createTime) {
                createTime = this.$options.filters['timeYMD'](this.tableData[i].createTime)
              }
              if (this.tableData[i].startTime) {
                if(this.tableData[i].feeFlag=='1003006'){
                  startTime = this.$options.filters['timeYMD'](this.tableData[i].startTime)
                }else{
                  startTime='-'
                }
               
              }
              if (this.tableData[i].endTime) {
                if(this.tableData[i].feeFlag=='1003006'){
                  endTime = this.$options.filters['timeYMD'](this.tableData[i].endTime)
                }else{
                  endTime='-'
                }
              }
              payMethod = this.$getPayMethodName(this.tableData[i].payMethod)
              newArr.push({
                'ownerName': this.tableData[i].ownerName,
                'mobile': this.tableData[i].mobile,
                'gardenName': this.tableData[i].gardenName,
                'houseName': this.tableData[i].houseName,
                'unitName': this.tableData[i].unitName,
                'roomName': this.tableData[i].roomName,
                'buildArea': this.tableData[i].buildArea,
                'feeName': this.tableData[i].feeName,
                'receivedAmount': this.tableData[i].receivedAmount,
                'createTime': createTime,
                'startTime': startTime,
                'endTime':endTime,
                'stateName': this.tableData[i].stateName,
                'payMethod':payMethod,
                'remark': this.tableData[i].remark
              })
            }
          }


          // 对应table数据的列字段名
          const filterVal = ['ownerName', 'mobile', 'gardenName', 'houseName', 'unitName', 'roomName', 'buildArea','feeName',
          'receivedAmount','createTime','startTime','endTime','stateName','payMethod','remark'
          ]
          excelDownload(tHeader, filterVal, newArr, "实收查询报表")
        } else {
          this.$message.error(this.$i18n.t('lang.lab_Online'))
        }
      },
    saveFile(fileForm){
     this.filesList=[]
      console.log(fileForm)
       if (this.fileList.length > 0) {
          for (let i = 0; i < this.fileList.length; i++) {
            if (this.fileList[i].url.indexOf('blob') != -1) {
              this.filesList.push(this.fileList[i].response.data[0])
            } else {
              this.filesList.push(this.fileList[i].url)
            }
          }
        }
        if (this.filesList.length==0) {
             this.$message.error('请选择选择文件并上传服务器')
            return
        }
         let loading = this.$loading()
               let params = {
                gardenId: this.gardenId,
								operPerson: '10006',
                urls: this.filesList,
              }
              this.$postJson(`/feePayDetailUrls`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.dialogShow = false
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
          )
    },
  // 移除图片
      removeFile(e) {
        let list = []
        for (let i = 0; i < this.fileList.length; i++) {
          if (this.fileList[i].url === e) {

          } else {
            list.push(this.fileList[i])
          }
        }
        this.fileList = list
        this.filesList = JSON.parse(JSON.stringify(list))
      },
      getFile(e,f) {
        this.fileList.push({
          name:f,
          url: e
        })
      },
     clear() {
        this.$refs.fileForm.resetFields()
      },
      // 监听关闭dialog
      handleDialogClosed() {
        this.clear()
      },
    uploadFileDialog(){
      this.filesList=[]
      this.fileList=[]
      this.dialogShow =true
        let loading = this.$loading()
        let params = {
               gardenId: this.gardenId
        }
       this.$get(`/getFeePayDetailUrls/`, params).then(
              (res) => {
                loading.close()
                if (res && res.errCode === 0) {
                   for (let i = 0; i < res.urls.length; i++) {
                        this.filesList.push({
                        name: res.urls[i].realName,
                        url: res.urls[i].url
                        }) 
                        this.fileList.push({
                        name: res.urls[i].realName,
                        url: res.urls[i].url
                        })  
                   }
                  console.log(this.filesList) 
                   console.log(this.fileList) 
              }
              },
              (error) => {
                loading.close()
                this.$message.error(error)
              }
            )
    },
    getRowKeys(row) {
      return row.detailId
    },
    rowClick(row, event) {
        let loading = this.$loading()
        let params = {
                detailId: row.detailId
        }
       this.$get(`/feeActualListByGardenId/`, params).then(
              (res) => {
                loading.close()
                if (res && res.errCode === 0) {
                    this.tableData.forEach((temp, index) => {
                      if (temp.detailId === row.detailId) {
                        res.list.map((item, index) => {
                            this.$set(item, 'feeFlag', row.feeFlag)
                        })
                        this.tableData[index].ruleItemData = res.list
                        console.log(res.list)
                      }
                  })
                  // this.pageCount = res.pageCount
                }
              },
              (error) => {
                loading.close()
                this.$message.error(error)
              }
            )
    },
      feeDetailHistory() {
          var startTs = ''
          var endTs = ''
          if (this.startTime != '' && this.startTime != null && this.startTime != undefined) {
            startTs = this.startTime
          }
          if (this.endTime != '' && this.endTime != null && this.endTime != undefined) {
            endTs = this.endTime
          }
            let loading = this.$loading()
            let params = {
              pageNo: this.pageNo,
              pageSize: this.pageSize,
              gardenId: this.gardenId,
              houseId: this.houseId,
              unitId: this.unitid,
              roomId: this.roomid,
              startTs: startTs,
              endTs: endTs,
              payMethod: this.payMethod,
              rName: this.keyword,
              state: '1400',
              feeName:this.searchFeeName,
              isWaiver: this.switchValue,
              isBackFee: this.isBackFee
            }
            this.$get(`/payFeeDetailHistory/`, params).then(
              (res) => {
                loading.close()
                if (res && res.errCode === 0) {
                   this.receivedAmountCount = ''
                   if (res.list != null && res.list.length > 0) {
                      this.receivedAmountCount = res.list[0].receivedAmountCount
                   }
                  res.list.map(item => {
                      item.ruleItemData = []
                  })
                  this.tableData = res.list
                  this.pageCount = res.pageCount
                  this.expands = []
                }
                 this.isExpand = true
                  if(this.isBackFee){
                  this.isBackButton=1
                }else{
                  this.isBackButton=0
                }
              },
              (error) => {
                loading.close()
                this.$message.error(error)
              }
            )
          },

    // 初始化时间组件
    getDatePicker() {
      let d = new Date()
      let year1, month1, day1
      [year1, month1, day1] = [d.getFullYear(), d.getMonth() + 1, 0]
      let date1 = new Date(year1, month1, day1).getTime()
      this.endTime = date1
      let year2, month2, day2
      [year2, month2, day2] = [d.getFullYear(), d.getMonth(), 1]
      let date2 = new Date(year2, month2, day2).getTime()
      this.startTime = date2
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    // 列表斑马线
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 添加多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 改变小区
    gardenChange() {
      this.houseId = ''
      this.unitid = ''
      this.roomid = ''
      this.unitList = ''
      this.roomList = ''
      this.type = 1
      this.saveFilterCache()
      this.gardenGrids(this.gardenId)
      this.feeDetailHistory()
    },
    fetchGardenGrids(parentId) {
      return this.$get(
        `/gardenGrids?type=${this.type}&parentId=${parentId}&pageNo=1&pageSize=999`
      ).then((res) => {
        if (res && res.errCode === 0) {
          if (this.type === 1) {
            this.floorList = res.list
          } else if (this.type === 2) {
            this.unitList = res.list
            this.roomList = ''
            if (this.houseId === '') {
              this.unitList = ''
              this.roomList = ''
            }
          } else if (this.type === 3) {
            this.roomList = res.list
            if (this.unitid === '') {
              this.roomList = ''
            }
          }
        }
        return res
      })
    },
    // 获取楼号单元号房间号
    gardenGrids(parentId) {
      let loading = this.$loading()
      this.fetchGardenGrids(parentId).then(
        () => {
          loading.close()
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 提交
    submit() {
      this.pageNo = 1
      this.saveFilterCache()
      this.feeDetailHistory()
    },
    // 通过楼层选择单元号
    selectUnit() {
      this.type = 2
      this.gardenGrids(this.houseId)
      this.unitid = ''
      this.roomid = ''
    },
    // 通过单元选择房间号
    selectRoom() {
      this.type = 3
      this.gardenGrids(this.unitid)
      this.roomid = ''
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.feeDetailHistory()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.feeDetailHistory()
    },
  },
  filters: {
    rounding (value) {
      if (value == undefined || value == '') {
          value = 0
      }
     return value.toFixed(2)
    }
  }
}
</script>

<style lang= 'scss' scoped>

</style>
